import { IFormValues } from '../../popups/HospitalizationModal/form/types';

const createValues: IFormValues = {
  date: '',
  reason: '',
};

export default createValues;
